import { render, staticRenderFns } from "./BusinessHandling.vue?vue&type=template&id=156e3d61&scoped=true&"
import script from "./BusinessHandling.vue?vue&type=script&lang=js&"
export * from "./BusinessHandling.vue?vue&type=script&lang=js&"
import style0 from "./BusinessHandling.vue?vue&type=style&index=0&lang=less&"
import style1 from "./BusinessHandling.vue?vue&type=style&index=1&id=156e3d61&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156e3d61",
  null
  
)

export default component.exports